import { makeStyles, tokens } from '@fluentui/react-components'

const useStyles = makeStyles({
  container: {
    padding: tokens.spacingHorizontalS,
    height: '100%',
    boxSizing: 'border-box',
    backgroundColor: tokens.colorNeutralBackground1,
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
  },
  addButton: {
    color: tokens.colorBrandForeground1,
    minWidth: 0,
  },
  pageContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
    backgroundColor: tokens.colorNeutralBackground1,
  },
  workingDocument: {
    marginTop: tokens.spacingVerticalXXS,
    marginBottom: tokens.spacingVerticalXXS,
  },
  pageInnerContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '30vh',
    gap: tokens.spacingVerticalMNudge,
  },
  filesListSection: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    gap: tokens.spacingHorizontalMNudge,
    paddingBottom: tokens.spacingVerticalMNudge,
  },
  spinner: {
    margin: 'auto',
  },
  selectAllRow: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalNone} ${tokens.spacingVerticalXS} ${tokens.spacingHorizontalXXXL}`,
    width: '100%',
    boxSizing: 'border-box',
  },
})

export { useStyles }
